@if (formItem && formItem.isVisible) {
  @switch (formItem.type) {
    <!-- Input -->
    @case ('text') {
      <mat-form-field
        [appearance]="componentConfig.appearance || 'outline'"
        [ngClass]="matFormFieldClass ? matFormFieldClass : 'w-100'"
        [disabled]="formItem.isDisabled"
      >
        <mat-label>{{ formItem.label }}</mat-label>
        <input
          matInput
          [readonly]="formItem.isReadOnly || !formItem.isEditable"
          *bitfUiRoleManager="componentConfig.uiRole"
          type="text"
          [placeholder]="formItem.placeholder || formItem.label"
          [formControl]="formControl"
        />
      </mat-form-field>
    }
    @case ('number') {
      <mat-form-field
        [appearance]="componentConfig.appearance || 'outline'"
        [ngClass]="matFormFieldClass ? matFormFieldClass : 'w-100'"
        [disabled]="formItem.isDisabled"
      >
        <mat-label>{{ formItem.label }}</mat-label>
        <input
          matInput
          *bitfUiRoleManager="componentConfig.uiRole"
          type="number"
          [readonly]="formItem.isReadOnly || !formItem.isEditable"
          [placeholder]="formItem.placeholder || formItem.label"
          [formControl]="formControl"
        />
      </mat-form-field>
    }
    @case ('mask') {
      <mat-form-field
        [appearance]="componentConfig.appearance || 'outline'"
        [ngClass]="matFormFieldClass ? matFormFieldClass : 'w-100'"
        [disabled]="formItem.isDisabled"
      >
        <mat-label>{{ formItem.label }}</mat-label>
        <input
          matInput
          *bitfUiRoleManager="componentConfig.uiRole"
          type="text"
          [readonly]="formItem.isReadOnly || !formItem.isEditable"
          [placeholder]="formItem.placeholder || formItem.label"
          [formControl]="formControl"
        />
      </mat-form-field>
    }
    <!-- Autocomplete -->
    @case ('autocomplete') {
      <mat-form-field
        [ngClass]="matFormFieldClass ? matFormFieldClass : 'w-100'"
        [appearance]="componentConfig.appearance || 'outline'"
        [disabled]="formItem.isDisabled"
      >
        <mat-label>{{ formItem.label }}</mat-label>
        <input
          matInput
          [readonly]="formItem.isReadOnly || !formItem.isEditable"
          [placeholder]="formItem.placeholder || formItem.label"
          *bitfUiRoleManager="componentConfig.uiRole"
          [matAutocomplete]="auto"
          [formControl]="formControl"
          (blur)="onAutocompleteBlur()"
        />
        @if (!showLoader) {
          <mat-icon matSuffix>search</mat-icon>
        }
        @if (showLoader) {
          <mat-spinner matSuffix [diameter]="20"></mat-spinner>
        }
        <mat-autocomplete
          #auto="matAutocomplete"
          [displayWith]="displayFn.bind(this)"
          (optionSelected)="onSelectionChange($event)"
        >
          @for (data of componentConfig.autocompleteData; track data) {
            <mat-option [value]="componentConfig?.useObject ? data : data?.id">
              {{ data['label'] }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    }
    <!-- Autocomplete with chips -->
    @case ('autocomplete-chips') {
      <mat-form-field
        [ngClass]="matFormFieldClass ? matFormFieldClass : 'w-100'"
        [appearance]="componentConfig.appearance || 'outline'"
        [disabled]="formItem.isDisabled"
      >
        <mat-label>{{ formItem.label }}</mat-label>
        <mat-chip-grid #chipList>
          @for (chip of chips; track chip; let i = $index) {
            <mat-chip-row
              [removable]="!formItem.isReadOnly && formItem.isEditable && !formItem.isDisabled"
              (removed)="removeChip(i)"
            >
              {{ chip }}
              @if (!formItem.isReadOnly && formItem.isEditable && !formItem.isDisabled) {
                <button matChipRemove>
                  <mat-icon>cancel</mat-icon>
                </button>
              }
            </mat-chip-row>
          }
          <input
            matInput
            #chipInput
            [readonly]="formItem.isReadOnly || !formItem.isEditable"
            [placeholder]="formItem.placeholder || formItem.label"
            *bitfUiRoleManager="componentConfig.uiRole"
            [matChipInputFor]="chipList"
            [matAutocomplete]="auto"
            matChipInputAddOnBlur="true"
            (matChipInputTokenEnd)="onMatChipInputTokenEnd($event)"
            [formControl]="formControl"
          />
        </mat-chip-grid>
        @if (!showLoader) {
          <mat-icon matSuffix>search</mat-icon>
        }
        @if (showLoader) {
          <mat-spinner matSuffix [diameter]="20"></mat-spinner>
        }
        <mat-autocomplete
          #auto="matAutocomplete"
          [displayWith]="displayFn.bind(this)"
          (optionSelected)="onChipsSelectionChange($event)"
        >
          @for (data of filteredAutocompleteChipsData; track data) {
            <mat-option [value]="componentConfig?.useObject ? data : data?.id">
              {{ data['label'] }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    }
    <!-- Date -->
    @case ('date') {
      <mat-form-field
        [appearance]="componentConfig.appearance || 'outline'"
        [ngClass]="matFormFieldClass ? matFormFieldClass : 'w-100'"
      >
        <mat-label>{{ formItem.label }}</mat-label>
        <input
          matInput
          *bitfUiRoleManager="componentConfig.uiRole"
          [matDatepicker]="pickerDate"
          [min]="formItem.metaData?.minDate"
          [max]="formItem.metaData?.maxDate"
          [placeholder]="formItem.placeholder || formItem.label"
          [formControl]="formControl"
          [readonly]="true"
          (dateChange)="onDateChange()"
          (click)="toggleDatePicker()"
        />
        @if (!formItem.isReadOnly && formItem.isEditable && formControl.value) {
          <button mat-icon-button matSuffix type="button" (click)="deleteValue()">
            <mat-icon>close</mat-icon>
          </button>
        }
        <mat-datepicker-toggle
          matPrefix
          *bitfUiRoleManager="hiddenUIRole"
          [for]="pickerDate"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerDate></mat-datepicker>
      </mat-form-field>
    }
    @case ('date-range') {
      <mat-form-field
        [ngClass]="matFormFieldClass ? matFormFieldClass : 'w-100'"
        [appearance]="componentConfig.appearance || 'outline'"
      >
        <mat-label>{{ formItem.label }}</mat-label>
        <mat-date-range-input [rangePicker]="dateRangePicker">
          <input
            matStartDate
            (dateChange)="onDateChange()"
            [placeholder]="formItem.placeholder || formItem.label"
          />
          <input
            matEndDate
            (dateChange)="onDateChange()"
            [placeholder]="formItem.placeholder || formItem.label"
          />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
        <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
      </mat-form-field>
    }
    <!-- Textarea -->
    @case ('textarea') {
      <mat-form-field
        [appearance]="componentConfig.appearance || 'outline'"
        [ngClass]="matFormFieldClass ? matFormFieldClass : 'w-100'"
        [disabled]="formItem.isDisabled"
      >
        <mat-label>{{ formItem.label }}</mat-label>
        <textarea
          matInput
          cdkTextareaAutosize
          [readonly]="formItem.isReadOnly || !formItem.isEditable"
          #autosize="cdkTextareaAutosize"
          cdkAutosizeMinRows="2"
          cdkAutosizeMaxRows="10"
          [formControl]="formControl"
          *bitfUiRoleManager="componentConfig.uiRole"
          [placeholder]="formItem.placeholder || formItem.label"
        ></textarea>
      </mat-form-field>
    }
    <!-- Checkbox -->
    @case ('checkbox') {
      <div>
        <mat-checkbox
          [disabled]="formItem.isDisabled || !canAction()"
          color="primary"
          class="text-left"
          [formControl]="formControl"
          (change)="onSelectionChange($event)"
        >
          <span class="label-wrap">{{ formItem.label }}</span>
        </mat-checkbox>
      </div>
    }
    <!-- Slide Toggle -->
    @case ('slide-toggle') {
      <div class="mb-3">
        <mat-slide-toggle
          [disabled]="formItem.isDisabled || !canAction()"
          color="primary"
          [formControl]="formControl"
          >{{ formItem.label }}</mat-slide-toggle
        >
      </div>
    }
    <!-- Chips -->
    @case ('chips') {
      <div class="mb-3">
        <mat-chip-listbox
          [formControl]="formControl"
          [multiple]="multiple"
          [disabled]="formItem.isDisabled || !canAction()"
          (change)="onSelectionChange($event)"
        >
          @for (option of formItem.options; track option) {
            <mat-chip-option [value]="option.id" [selected]="isChipSelected(option.id)" color="primary">
              {{ option.label }}
              <!-- <mat-icon matChipRemove>cancel</mat-icon> -->
            </mat-chip-option>
          }
        </mat-chip-listbox>
      </div>
    }
  }
}

<ng-template #inputTextNumeric> </ng-template>
